// extracted by mini-css-extract-plugin
module.exports = {"required":"FormLeaveType_required_1DaeB","error":"FormLeaveType_error_3emw4","radioBox":"FormLeaveType_radioBox_AkHM1","label":"FormLeaveType_label_wad8e"};